import { makeStyles } from '@material-ui/core/styles';

export const useImageGalleryStyles = makeStyles(theme => ({
  gallery: {
    width: '100%',
    margin: '0px !important'
  },
  link: { fontSize: '1.38rem' }
}));
